import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { YearpickerTypeComponent } from './yearpicker-type.component';
import { MatIconModule } from '@angular/material/icon';
import {
  DatepickerMaskDirective,
  MatFormFieldYearPickerDirective,
} from '@lockton-apps/shared/ui/lui';

@NgModule({
  declarations: [YearpickerTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DatepickerMaskDirective,
    MatFormFieldYearPickerDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'yearpicker',
          component: YearpickerTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
        },
      ],
    }),
    MatIconModule,
  ],
})
export class YearpickerTypeModule {}
